const URL = process.env.NODE_ENV === 'production' ? 'https://api.sxjy.cq.cn/' : 'https://api.sxjy.cq.cn/';
export default URL;